import { usePolicyAcceptance, type PolicyAcceptanceNotificationSource } from '../contexts/PolicyAcceptanceContext';
import { NotificationTypeId } from '../utils/notificationMeta';

export type { PolicyAcceptanceNotificationSource };

export function usePolicyAcceptanceFromNotification() {
  const { openFromNotification } = usePolicyAcceptance();

  const handleNotificationClick = (
    notification: PolicyAcceptanceNotificationSource,
    onAccepted?: () => void,
  ): boolean => openFromNotification(notification, onAccepted);

  const isPolicyUpdateNotification = (typeId: number) => typeId === NotificationTypeId.RuleUpdate;

  return {
    handleNotificationClick,
    isPolicyUpdateNotification,
  };
}
